import YUSPUtil from '../../../core/util/yusp_util';

import { RrRepository } from '../../../core/repositories/rr_repository';
import { CategoryLlAndL } from '../models/category_ll_and_l';
import { JsEnv, isSoloare, SiteType } from '../../../core/models/js_env';
import { createRrRequestParam } from '../models/set_rr_request';
import { getRrAreaData } from '../../../core/models/rr/rr_util';
import { CategoryLlAndLContainer } from '../views/pc/category_ll_and_l_container';
import { CatalogItemCodesWithElementId, doShowRtoaster } from '../../../core/models/rtoaster/rtoaster_utils';
import { Env } from '../../../core/env';
import LazyUtil from '../../../core/util/lazy_util';
import { cancelLoading, setLoadingTimer } from '../../../core/util/dom_util';

const RTOASTER_RECOMMEND_TITLE = 'あなたにオススメの商品';

export class CategoryLlAndLAction {
  private static state: CategoryLlAndL;
  private static rrRepository: RrRepository;

  static init(env: JsEnv) {
    this.state = new CategoryLlAndL(env.PAGE, env.SITE_TYPE);
    this.rrRepository = new RrRepository();
    const model = this.state.getModel();

    // サイトタイプがソロアリ以外かつ、おすすめ情報設定がOnかつ、他サプカテではない場合、RR取得処理を実行
    if (!isSoloare(env.SITE_TYPE) && model.shouldDisplayRecommend && !model.isSupplierCategory) {
      if (window['RR'] !== undefined) {
        if (model.isFromExternalSite) {
          // 外部流入レコメンドを表示する場合、ローディング中モジュールを表示させるため、
          // タイマーを設定する(RR応答遅延等を考慮し、タイマー満了時にローディングを解除)
          const timeoutId = setLoadingTimer(model.rrAreaProfileL1.placementName);
          model.rrAreaProfileL1.timeoutId = timeoutId;
        }
        window['RR'].jsonCallback = this.renderRr.bind(this);
        this.rrRepository.sendRequestToRrServer(createRrRequestParam(model), false);
      } else if (model.isFromExternalSite) {
        // RR未定義の場合はRR送信しないため、ローディングモジュールを即解除
        cancelLoading(model.rrAreaProfileL1.placementName);
      }
    }

    // サイトタイプがソロアリかつ、おすすめ情報設定がOnかつ、他サプカテではない場合、RR取得処理を実行
    // Rtoasterは削除予定なので下の分岐とは独立させておく
    if (isSoloare(env.SITE_TYPE) && model.shouldDisplayRecommend && !model.isSupplierCategory) {
      this.rrRepository.sendRequestToRrServer(createRrRequestParam(model), true);
    }

    // サイトタイプがソロアリかつ、おすすめ情報設定がOnかつ、他サプカテではない場合、Rtoaster取得処理を実行
    if (isSoloare(env.SITE_TYPE) && model.shouldDisplayRecommend && !model.isSupplierCategory && typeof Rtoaster !== 'undefined') {
      const elementIds = (model.isLlCategory) ? ['tr_recom_dai_dai'] : ['tr_recom_dai'];

      doShowRtoaster({
        elementIds: elementIds,
        showRtoasterAreaCallBack: this.showRtoasterArea.bind(this),
      });
    }
    // YUSP連携 ユーザーID連携、VIEWイベント
    YUSPUtil.register({
      enableUserId: true,
      enableView: true
    });

    // 外部ファイルにjsが含まれた場合、実行されるよう
    LazyUtil.enableExternalFileScript();
  }

  private static async showRtoasterArea(catalogItemCodesWithElementIds: CatalogItemCodesWithElementId[]) {
    const state = this.state;
    const model = state.getModel();

    // 1件しか返ってこないため、[0]で参照する
    const catalogItemCodes = (catalogItemCodesWithElementIds.length !== 0) ? catalogItemCodesWithElementIds[0].catalogItemCodes : [];
    const carouselItems = await this.rrRepository.getRrItemsDetail(catalogItemCodes, false, SiteType.SOLOARE, Env.PAGE.categoryLlCode, Env.PAGE.categoryLCode);

    if (model.isLlCategory) {
      state.setRrAreaDataLl1(carouselItems, RTOASTER_RECOMMEND_TITLE);
    } else {
      state.setRrAreaDataL1(carouselItems, RTOASTER_RECOMMEND_TITLE);
    }

    new CategoryLlAndLContainer(model); // NOSONAR
  }

  private static async renderRr() {
    const state = this.state
    const model = state.getModel()

    if (model.isLlCategory) {
      const rrDataLl1 = await getRrAreaData(model.rrAreaProfileLl1)
      state.setRrAreaDataLl1(rrDataLl1.items, rrDataLl1.title);

      const rrDataLl2 = await getRrAreaData(model.rrAreaProfileLl2)
      state.setRrAreaDataLl2(rrDataLl2.items, rrDataLl2.title);

    }

    if (!model.isLlCategory) {
      if (model.isFromExternalSite) {// 外部流入版RRエリアは、外部流入時のみ表示する
        const rrDataL1 = await getRrAreaData(model.rrAreaProfileL1)
        state.setRrAreaDataL1(rrDataL1.items, rrDataL1.title);
      }

      const rrDataL2 = await getRrAreaData(model.rrAreaProfileL2)
      state.setRrAreaDataL2(rrDataL2.items, rrDataL2.title);

      const rrDataL3 = await getRrAreaData(model.rrAreaProfileL3)
      state.setRrAreaDataL3(rrDataL3.items, rrDataL3.title);
    }
    return new CategoryLlAndLContainer(model);
  }
}
